import { GridRowId } from "@mui/x-data-grid";
import httpClient from "../../api/httpClient";
import ProdutoAcabado from "../classes/ProdutoAcabado";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "ProdutoAcabado/All/" },
  { method: "GET", rota: "ProdutoAcabado/One" },
  { method: "POST", rota: "ProdutoAcabado/Adicionar" },
  { method: "PUT", rota: "ProdutoAcabado/Atualizar" },
  { method: "DELETE", rota: "ProdutoAcabado/Apagar" },
  { method: "POST", rota: "ProdutoAcabado/Integrar" },
  { method: "PUT", rota: "ProdutoAcabado/Estornar/" },
  { method: "PUT", rota: "ProdutoAcabado/AtualizarOrigem/" }
];

const cacheKey: string = "ProdutoAcabadoCache";
const cacheKeySelC: string = "ProdutoAcabadoCacheSelecionado";

const apiServico: String = "PLANEJAMENTO";

class ProdutoAcabadoDataSet extends httpClient {
  
  constructor() {
    super(String(apiServico));
  }

  async Adicionar(value: ProdutoAcabado): Promise<ProdutoAcabado> {
    return await super.post(calls[2].rota, value);
  }

  async Atualizar(value: ProdutoAcabado[]) {
    return await super.put(calls[3].rota, value);
  }

  async AtualizarOrigem(produtoAcabadoId: number, origem: string) {
    return await super.put(calls[7].rota+`?origem=${origem}&id=${produtoAcabadoId}`, {});
  }

  Apagar(value: ProdutoAcabado) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .delete(calls[4].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  Integrar(value: ProdutoAcabado[]) {
    return super.post(calls[5].rota, value).then((result) => {
      return result;
    });
  }

  async ListarAtivosPorContratoStep(
    codigoFornecedorSap: Number,
    numeroContrato: string,
    step: number
  ): Promise<ProdutoAcabado[]> {
    return await super
      .Get(
        calls[0].rota +
          codigoFornecedorSap +
          "/" +
          numeroContrato +
          "/Step/" +
          step
      )
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro);
      });
  }

  async ListarAtivos(
    codigoFornecedorSap: Number
  ): Promise<ProdutoAcabado[]> {
    return await super
      .Get(
        calls[0].rota +
          codigoFornecedorSap
      )
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro);
      });
  }

  async Estornar(step: number, value: ProdutoAcabado[]) {
    try {
      const result = await super.put(calls[6].rota + step, value);
      return JSON.parse(result);
    } catch (erro) {
        console.log(erro);
        return false;
    }
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): ProdutoAcabado[] {
    let result: ProdutoAcabado[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: ProdutoAcabado[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
export default ProdutoAcabadoDataSet;
